import _regeneratorRuntime from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import dayjs from 'dayjs';
export default {
  name: 'mng_user',
  data: function data() {
    return {
      dayjs: dayjs,
      currentUser: localStorage.getItem('userId'),
      pageConfig: {
        editPageName: '用户',
        addFunName: 'mngUserAdd',
        modifyFunName: 'mngUserModify',
        queryFunName: 'mngUserQueryDoNotHaveAdmin',
        detailFunName: 'mngUserDetail',
        disableFunName: 'mngUserDisable',
        unDisableFunName: 'mngUserUnDisable',
        unLockFunName: 'mngUserUnLock',
        resetPasswordFunName: 'mngUserResetPassword',
        addBalanceFunName: 'mngUserAddBalance',
        subBalanceFunName: 'mngUserSubBalance',
        clearAuthFunName: 'mngUserClearAuth',
        dicTreeFunName: 'mngDictionaryLowerTree'
      },
      dicData: {
        categoryUpperCode: 'mng_user_category',
        configCategorys: [],
        configCategoryOptions: {},
        typeUpperCode: 'mng_user_type',
        configTypes: [],
        configTypeOptions: {}
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        category: null,
        userType: null,
        state: null,
        sortField: 'create_time'
      },
      formData: {
        id: null,
        category: null,
        state: 'active',
        account: null,
        nickname: null,
        name: null,
        gender: null,
        birthdate: null,
        image: null,
        phone: null,
        remark: null,
        mobileId: null
      },
      formBalanceData: {
        id: null,
        currentBalance: null,
        operationType: null,
        balance: null,
        content: null
      },
      rules: {
        account: [{
          required: true,
          message: '帐号不能为空',
          trigger: 'blur'
        }],
        category: [{
          required: true,
          message: '类别不能为空',
          trigger: 'blur'
        }]
      },
      balanceRules: {
        balance: [{
          required: true,
          message: '变更余额不能为空',
          trigger: 'blur'
        }, {
          pattern: /^(([0-9]+)|([0-9]+\.[0-9]{0,2}))$/,
          message: '变更余额必须为有效金额',
          trigger: 'blur'
        }],
        content: [{
          required: true,
          message: '变更余额原因不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      balanceDialogShow: false,
      balanceDialogTitle: '',
      formLabelWidth: '70px',
      formLabelLowWidth: '50px',
      formBalanceLabelWidth: '100px',
      emptyFormData: {},
      emptyBalanceFormData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    this.emptyBalanceFormData = JSON.parse(JSON.stringify(this.formBalanceData));
    Promise.all([new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.categoryUpperCode).then(function (res) {
        if (res.data) {
          for (var i = 0; i < res.data.length; i++) {
            if (res.data[i].code !== 'admin') {
              _this.dicData.configCategorys.push(res.data[i]);
              _this.dicData.configCategoryOptions[res.data[i].code] = res.data[i].name;
            }
          }
        }
        resolve(res);
      });
    }), new Promise(function (resolve, reject) {
      _this.$api[_this.pageConfig.dicTreeFunName](_this.dicData.typeUpperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configTypes = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configTypeOptions[res.data[i].code] = res.data[i].name;
          }
        }
        resolve(res);
      });
    })]).then(function (result) {
      _this.query();
    });
  },
  methods: {
    beforeCommand: function beforeCommand(index, row, command) {
      return {
        index: index,
        row: row,
        command: command
      };
    },
    moreButton: function moreButton(command) {
      switch (command.command) {
        case 'address':
          this.address(command.row);
          break;
        case 'unLock':
          // 解除锁定
          this.unLock(command.row.id);
          break;
        case 'disable':
          // 封禁用户
          this.disableUser(command.row.id);
          break;
        case 'unDisable':
          // 解封用户
          this.unDisableUser(command.row.id);
          break;
        case 'resetPassword':
          // 重置密码
          this.resetPassword(command.row.id);
          break;
        case 'addBalance':
          // 增加余额
          this.addBalance(command.row.id);
          break;
        case 'subBalance':
          // 扣减余额
          this.subBalance(command.row.id);
          break;
        case 'clear':
          // 清理用户
          this.clearUser(command.row.id);
          break;
      }
    },
    address: function address(user) {
      this.$emit('child-go', user, 'userAddress');
    },
    unLock: function unLock(userId) {
      var _this2 = this;
      this.$confirm('确定解锁当前用户吗').then(function () {
        _this2.$api[_this2.pageConfig.unLockFunName](userId).then(function (res) {
          if (res.data) {
            _this2.$message.success('解锁成功');
            _this2.query();
          } else {
            _this2.$message.error('解锁失败');
          }
        });
      });
    },
    disableUser: function disableUser(userId) {
      var _this3 = this;
      this.$confirm('确定封禁当前用户吗').then(function () {
        _this3.$api[_this3.pageConfig.disableFunName](userId).then(function (res) {
          if (res.data) {
            _this3.$message.success('封禁成功');
            _this3.query();
          } else {
            _this3.$message.error('封禁失败');
          }
        });
      });
    },
    unDisableUser: function unDisableUser(userId) {
      var _this4 = this;
      this.$confirm('确定解禁当前用户吗').then(function () {
        _this4.$api[_this4.pageConfig.unDisableFunName](userId).then(function (res) {
          if (res.data) {
            _this4.$message.success('解禁成功');
            _this4.query();
          } else {
            _this4.$message.error('解禁失败');
          }
        });
      });
    },
    resetPassword: function resetPassword(userId) {
      var _this5 = this;
      this.$confirm('确定重置当前用户密码吗').then(function () {
        _this5.$api[_this5.pageConfig.resetPasswordFunName](userId).then(function (res) {
          if (res.data) {
            _this5.$message.success('重置成功');
            _this5.query();
          } else {
            _this5.$message.error('重置失败');
          }
        });
      });
    },
    addBalance: function addBalance(userId) {
      var _this6 = this;
      this.$api[this.pageConfig.detailFunName](userId).then(function (res) {
        _this6.formBalanceData.id = res.data.id;
        _this6.formBalanceData.operationType = 'add';
        _this6.formBalanceData.currentBalance = res.data.balanceCirculate;
        _this6.balanceDialogTitle = (res.data.nickname || res.data.account) + ' 增加余额';
        _this6.balanceDialogShow = true;
      });
    },
    subBalance: function subBalance(userId) {
      var _this7 = this;
      this.$api[this.pageConfig.detailFunName](userId).then(function (res) {
        _this7.formBalanceData.id = res.data.id;
        _this7.formBalanceData.operationType = 'sub';
        _this7.formBalanceData.currentBalance = res.data.balanceCirculate;
        _this7.balanceDialogTitle = (res.data.nickname || res.data.account) + ' 扣减余额';
        _this7.balanceDialogShow = true;
      });
    },
    clearUser: function clearUser(userId) {
      var _this8 = this;
      this.$confirm('确定清除用户吗？用户清除后将不能恢复').then(function () {
        _this8.$confirm('请再次确认，是否清除当前用户？').then(function () {
          _this8.$confirm('请谨慎操作！！！最后确认是否清除当前用户？').then(function () {
            _this8.$api[_this8.pageConfig.clearAuthFunName](userId).then(function (res) {
              if (res.data) {
                _this8.$message.success('清除成功');
                _this8.query();
              } else {
                _this8.$message.error('清除失败');
              }
            });
          });
        });
      });
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      if (paramData.birthdate) {
        paramData.birthdate = paramData.birthdate.toString();
      }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    initBalanceFormData: function initBalanceFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      this.formBalanceData = paramData;
      if (typeof this.$refs['formBalanceDataVerify'] !== 'undefined') {
        this.$refs['formBalanceDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    upload: function upload(_ref) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this9.$api.aliOssSign(localStorage.getItem('userId')).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this9.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this9.formData.image = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    previewFile: function previewFile() {
      window.open(this.formData.image);
    },
    removeFile: function removeFile() {
      this.formData.image = '';
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(userId) {
      var _this10 = this;
      this.$api[this.pageConfig.detailFunName](userId).then(function (res) {
        _this10.initFormData(res.data);
        _this10.editDialogTitle = _this10.pageConfig.editPageName + '维护';
        _this10.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this11 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this11.$api[_this11.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this11.$message.success('删除成功');
            _this11.query();
          } else {
            _this11.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this12 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this12.tableData = res.data || [];
        _this12.totalCount = res.count;
        _this12.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this13 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this13.formData.id) {
            _this13.$api[_this13.pageConfig.modifyFunName](_this13.saveFormDataProcess(_this13.formData)).then(function (res) {
              if (res.data) {
                _this13.$message.success('编辑成功');
                _this13.initFormData(_this13.emptyFormData);
                _this13.editDialogShow = false;
                _this13.query();
              } else {
                _this13.$message.error('编辑失败');
              }
            });
          } else {
            _this13.$api[_this13.pageConfig.addFunName](_this13.saveFormDataProcess(_this13.formData)).then(function (res) {
              if (res.data) {
                _this13.$message.success('新增成功');
                _this13.initFormData(_this13.emptyFormData);
                _this13.editDialogShow = false;
                _this13.query();
              } else {
                _this13.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    submitBalanceFormData: function submitBalanceFormData() {
      var _this14 = this;
      this.$refs['formBalanceDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this14.formBalanceData.operationType === 'add') {
            _this14.$api[_this14.pageConfig.addBalanceFunName](_this14.formBalanceData.id, _this14.formBalanceData.balance, _this14.formBalanceData.content).then(function (res) {
              if (res.data) {
                _this14.$message.success('增加成功');
                _this14.initBalanceFormData(_this14.emptyBalanceFormData);
                _this14.balanceDialogShow = false;
                _this14.query();
              } else {
                _this14.$message.error('增加失败');
              }
            });
          } else {
            _this14.$api[_this14.pageConfig.subBalanceFunName](_this14.formBalanceData.id, _this14.formBalanceData.balance, _this14.formBalanceData.content).then(function (res) {
              if (res.data) {
                _this14.$message.success('扣减成功');
                _this14.initBalanceFormData(_this14.emptyBalanceFormData);
                _this14.balanceDialogShow = false;
                _this14.query();
              } else {
                _this14.$message.error('扣减失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    closeBalanceEditDialogShow: function closeBalanceEditDialogShow() {
      this.balanceDialogTitle = '';
      this.balanceDialogShow = false;
      this.initBalanceFormData(this.emptyBalanceFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};